import { useCallback } from 'react';
import { useSignMessage } from 'wagmi';

/**
 * Thin wrapper around wagmi's `useSignMessage` for `personal_sign`.
 *
 * Used by the auth flow to sign the login challenge.
 *
 * @returns `signMessage` async function and `isPending` loading state
 */
export function useWalletSigner() {
    const { signMessageAsync, isPending, reset } = useSignMessage();

    const signMessage = useCallback(
        async (message: string): Promise<string> => {
            return signMessageAsync({ message });
        },
        [signMessageAsync],
    );

    return {
        /** Sign a message using personal_sign. Returns the signature hex. */
        signMessage,
        /** Whether a signing operation is currently pending. */
        isPending,
        /** Reset the signing state (clear errors). */
        reset,
    };
}
